import React, { useState } from 'react';

function Publications() {
  const publications = [
    {
      title: "Face Recognition Model based on the Laplacian Pyramid Fusion Technique.",
      journal: "International Journal of Advances in Soft Computing & Its Applications",
      year: 2021,
      link: "https://www.i-csrs.org/Volumes/ijasca/2021.1.2.pdf"
    },
    {
      title: "Face Recognition using Local Binary Pattern and Principle Component Analysis, Master's thesis in Computer Science.",
      conference: "AABU",
      year: 2018,
      link: "https://www.academia.edu/105776897/Face_Recognition_using_Local_Binary_Pattern_and_Principle_Component_Analysis"
    },
    {
      title: "Face Recognition Model Based on Covariance Intersection Fusion for Interactive devices.",
      journal: "World of Computer Science & Information Technology Journal",
      year: 2021,
      link: "https://ieeexplore.ieee.org/document/9634137"
    },
    {
      title: "Off-line handwritten verification model for processing bank checks based on truncated-SVD and support vector machine (SVM).",
      conference: " IEEE Jordan International Joint Conference",
      year: 2021,
      link: "https://www.mdpi.com/2306-5729/7/6/80"
    },
    {
      title: "Multi-Resolution Discrete Cosine Transform Fusion Technique Face Recognition Model.",
      journal: "MDPI",
      year: 2023,
      link: "https://www.mdpi.com/2306-5729/7/6/80"
    },

    {
      title: "Emotion Tracking System for Students during Online Exams.",
      journal: "IEEE 19th International Multi-Conference on Systems",
      year: 2022,
      link: "https://ieeexplore.ieee.org/document/9955652"
    },
    {
      title: "Students' performance-prediction-Model based on Physical and Physiological Constraints.",
      journal: "IEEE 19th International Multi-Conference on Systems",
      year: 2022,
      link: "https://ieeexplore.ieee.org/document/9955809"
    },
    {
      title: "Face recognition system based on the multi-resolution singular value decomposition fusion technique.",
      journal: "International Journal of Data and Network Science",
      year: 2022,
      link: "https://www.growingscience.com/ijds/Vol6/ijdns_2022_86.pdf"
    },
    {
      title: "An Automatic Paleography Script Recognition System for the Arabic Language based on Fast Independent Component Analysis (Fast-ICA) and Support Vector Machine (SVM)",
      journal:  " IEEE Jordan International Joint Conference",
      year: 2021,
      link: "https://ieeexplore.ieee.org/document/9634154"
    },
    {
      title: "Forensic Handwriting Identification System for the Arabic Language Based on Stationary Wavelet Transform (SWT) Fusion Technique.",
      journal:  " IEEE Jordan International Joint Conference",
      year: 2021,
      link: "https://ieeexplore.ieee.org/abstract/document/9634149/"
    }
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const publicationsPerPage = 3;

  const indexOfLastPublication = currentPage * publicationsPerPage;
  const indexOfFirstPublication = indexOfLastPublication - publicationsPerPage;
  const currentPublications = publications.slice(indexOfFirstPublication, indexOfLastPublication);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <section id="publications" className="section">
      <h2>Publications</h2>
      {currentPublications.map((pub, index) => (
        <div key={index} className="publication-item">
          <h3>{pub.title}</h3>
          <p>{pub.journal || pub.conference}, {pub.year}</p>
          <a className='textColor' href={pub.link} target="_blank" rel="noopener noreferrer">Read More</a>
        </div>
      ))}
      <Pagination
        publicationsPerPage={publicationsPerPage}
        totalPublications={publications.length}
        paginate={paginate}
        currentPage={currentPage}
      />
    </section>
  );
}

function Pagination({ publicationsPerPage, totalPublications, paginate, currentPage }) {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPublications / publicationsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className="pagination">
      {pageNumbers.map(number => (
        <button 
          key={number} 
          onClick={() => paginate(number)} 
          className={`page-btn ${currentPage === number ? 'active' : ''}`}
        >
          {number}
        </button>
      ))}
    </nav>
  );
}

export default Publications;